(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3743],{

/***/ 89982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97588);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import Mobile from '@/mobile-pages/board'



const PC = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(1389), __webpack_require__.e(8096), __webpack_require__.e(6384), __webpack_require__.e(2236), __webpack_require__.e(3184), __webpack_require__.e(3219), __webpack_require__.e(7433), __webpack_require__.e(4091), __webpack_require__.e(6777), __webpack_require__.e(8131), __webpack_require__.e(2793), __webpack_require__.e(6225), __webpack_require__.e(4233), __webpack_require__.e(3233), __webpack_require__.e(2456), __webpack_require__.e(3651), __webpack_require__.e(8352), __webpack_require__.e(1331), __webpack_require__.e(1450), __webpack_require__.e(7793), __webpack_require__.e(1290), __webpack_require__.e(652), __webpack_require__.e(1386), __webpack_require__.e(9366), __webpack_require__.e(8806), __webpack_require__.e(9458), __webpack_require__.e(2403), __webpack_require__.e(9460), __webpack_require__.e(9317), __webpack_require__.e(3601), __webpack_require__.e(2078), __webpack_require__.e(3463), __webpack_require__.e(4696), __webpack_require__.e(618), __webpack_require__.e(6189), __webpack_require__.e(6194), __webpack_require__.e(9583), __webpack_require__.e(794), __webpack_require__.e(5219), __webpack_require__.e(2367), __webpack_require__.e(599), __webpack_require__.e(6666), __webpack_require__.e(4775), __webpack_require__.e(2492), __webpack_require__.e(1500), __webpack_require__.e(3487), __webpack_require__.e(6458), __webpack_require__.e(2298), __webpack_require__.e(7423), __webpack_require__.e(8139), __webpack_require__.e(2414), __webpack_require__.e(4325), __webpack_require__.e(8674), __webpack_require__.e(6626), __webpack_require__.e(6589), __webpack_require__.e(6969)]).then(__webpack_require__.bind(__webpack_require__, 63240)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(63240)]
  }
});
const Mobile = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(2078), __webpack_require__.e(5480), __webpack_require__.e(7655)]).then(__webpack_require__.bind(__webpack_require__, 85278)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(85278)]
  }
});

const Board = props => {
  return (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Mobile, _objectSpread({}, props)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PC, _objectSpread({}, props));
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Board);

/***/ }),

/***/ 97588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



const useIsMobile = () => {
  var _window;

  const {
    isMobile
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.ssr);

  if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF && (_window = window) !== null && _window !== void 0 && _window.navigator.userAgent) {
    var _window2;

    return (0,_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq)((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.navigator.userAgent);
  }

  return isMobile;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);

/***/ }),

/***/ 37107:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board",
      function () {
        return __webpack_require__(89982);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3220,455,4050,8986,5695,3279,4136,9669,587,6205,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,9778,7971,1738,9161,6158,4071,3066], function() { return __webpack_exec__(37107); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);